import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";

import "jspdf-autotable";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Normal({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { LedgerNormaldata } = useSelector((state) => state.LedgerSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  }



  const formatIndianAmount = (value) => {
    if (!value) return "0.00";

    const str = String(value).trim();

    // Number extract
    const numberMatch = str.match(/-?\d+(\.\d+)?/);

    if (!numberMatch) return value;

    const num = Number(numberMatch[0]);

    // Cr / Dr extract
    const typeMatch = str.match(/\b(Cr|Dr)\b/i);
    const type = typeMatch ? typeMatch[0] : "";

    const formattedNumber = num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${formattedNumber} ${type}`.trim();
  };

  const getRows = LedgerNormaldata?.LedgerDtl?.map((label, index) => ({
    // srNumber: index + 1,
    Date: formatDateToDDMMYYYY(label.Date),
    Type: label.Type,
    VouNo: label.VouNo,
    ChqNo: label.ChqNo,
    Narration: label.Narration,
    Debit: label.Debit,
    Credit: label.Credit,
    Balance: label.Balance,
    AmtType: label.AmtType,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Date", key: "Date", align: "center" },
    {
      label: "Type",
      key: "Type",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Vou No", key: "VouNo", align: "right" },
    { label: "Chq No", key: "ChqNo", align: "right", rupees: true },
    {
      label: "Narration",
      key: "Narration",
      align: "right",
      width: "300px",
      wrap: true,
    },
    { label: "Debit", key: "Debit", align: "right", format: true },
    { label: "Credit", key: "Credit", align: "right", format: true },
    {
      label: "Balance",
      key: "Balance",
      align: "right",
      format: true,
      width: "150px",
    },
    { label: "Bal Type", key: "AmtType", align: "right" },
  ];

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const formatIndianNumber = (value) => {
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    // ----------------- Title -----------------
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");

    const title = "Ledger Normal Report";

    doc.text(title, pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    // ----------------- Firm Name -----------------
    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });

    // ----------------- Data -----------------
    const details = LedgerNormaldata?.LedgerOpening?.[0] || {};


    // direct redux data (blank issue fix)
    const openingAmount = LedgerNormaldata?.LedgerOpening?.[0]?.OpAmount || 0;

    const balanceAmount = LedgerNormaldata?.LedgerSumm?.[0]?.Balance || 0;

    let yPos = 35;

    // ----------------- Account Details -----------------
    doc.setFontSize(11);
    doc.setFont(undefined, "normal");

    doc.text(`A/c Name : ${details.AcName || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`Pan No : ${details.PanNo || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`Address : ${details.Address || "-"}`, marginX, yPos);
    yPos += 8;

    doc.text(`City : ${details.CityName || "-"}`, marginX, yPos);

    // ----------------- Opening & Balance -----------------

    const rightEdge = pageWidth - marginX;

    doc.setFont("helvetica", "bold");

    const openingText = `Opening : ${formatIndianAmount(openingAmount || 0)}`;

    const balanceText = `Balance : ${formatIndianAmount(balanceAmount || 0)}`;

    doc.text(openingText, rightEdge - doc.getTextWidth(openingText), 50);

    doc.text(balanceText, rightEdge - doc.getTextWidth(balanceText), 57);

    yPos += 14;
    doc.line(marginX, yPos, pageWidth - marginX, yPos);

    // ----------------- Table Data -----------------
    const tableRows =
      LedgerNormaldata?.LedgerDtl?.map((row, index) => [
        index + 1,
        formatDateToDDMMYYYY(row?.Date) || "-",
        row?.Type?.trim() || "-",
        row?.VouNo?.trim() || "-",
        row?.ChqNo?.trim() || "-",
        row?.Narration?.trim() || "-",
        formatIndianNumber(row?.Debit),
        formatIndianNumber(row?.Credit),
        formatIndianNumber(row?.Balance),
        row?.AmtType?.trim() || "-",
      ]) || [];

    // ----------------- Total -----------------
    const totalDebit =
      LedgerNormaldata?.LedgerDtl?.reduce(
        (sum, row) => sum + Number(row?.Debit || 0),
        0,
      ) || 0;

    const totalCredit =
      LedgerNormaldata?.LedgerDtl?.reduce(
        (sum, row) => sum + Number(row?.Credit || 0),
        0,
      ) || 0;

    const closingBalance = LedgerNormaldata?.LedgerDtl?.at(-1)?.Balance || 0;

    // Total row
    tableRows.push([
      "",
      "",
      "",
      "",
      "",
      "TOTAL",
      formatIndianNumber(totalDebit),
      formatIndianNumber(totalCredit),
      formatIndianNumber(closingBalance),
      "",
    ]);

    const pdfColumnStyles = {
      0: { cellWidth: 14 },
      1: { cellWidth: 22 },
      2: { cellWidth: 20 },
      3: { cellWidth: 22 },
      4: { cellWidth: 22 },
      5: { cellWidth: 72 },
      6: { cellWidth: 25 },
      7: { cellWidth: 25 },
      8: { cellWidth: 25 },
      9: { cellWidth: 20 },
    };
    getColumns.forEach((col, index) => {
      if (pdfColumnStyles[index]) {
        pdfColumnStyles[index].halign = col.align || "left";
      }
    });

    // ----------------- Table -----------------

    autoTable(doc, {
      startY: yPos + 7,

      tableWidth: pageWidth - 28, 

      head: [
        [
          "Sr. No.",
          "Date",
          "Type",
          "Vou No",
          "Chq No",
          "Narration",
          "Debit",
          "Credit",
          "Balance",
          "Bal Type",
        ],
      ],

      body: tableRows,

      theme: "grid",

      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },

      columnStyles: pdfColumnStyles,

      didParseCell: (data) => {
        if (data.section === "body") {
          if (typeof data.cell.text === "string") {
            data.cell.text = data.cell.text.trim();
          } else if (Array.isArray(data.cell.text)) {
            data.cell.text = data.cell.text.map((t) =>
              typeof t === "string" ? t.trim() : t,
            );
          }

          const colConfig = getColumns[data.column.index];
          if (colConfig) {
            data.cell.styles.halign = colConfig.align || "left";
          }
        }

        const isTotalRow = data.row.raw?.[5] === "TOTAL";

        if (isTotalRow && data.section === "body") {
          data.cell.styles.fillColor = [230, 230, 230];
          data.cell.styles.fontStyle = "bold";
        }
      },

      margin: {
        left: marginX,
        right: marginX,
      },

      showHead: "everyPage",

      didDrawPage: () => {
        const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;

        doc.setFontSize(8);
        doc.setTextColor(120);

        doc.text(`Page ${pageNumber}`, pageWidth - marginX, pageHeight - 5, {
          align: "right",
        });
      },
    });

    // ----------------- Save -----------------
    doc.save("Ledger_Normal_Report.pdf");
  };
  if (accountName.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          fontSize: "20px",
          color:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour10,
        }}
      >
        Please Select Accounts Name
      </div>
    );
  }
  if (LedgerNormaldata === "no" || LedgerNormaldata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000] ">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        paddingTop: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
      }}
    >
      <style>{`
            .common-hover-btn {
              transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease;
              transform: scale(1);
            }
            .common-hover-btn:hover {
              transform: scale(1.01);
            }
            .common-hover-btn:active {
              transform: scale(0.98);
            }
                .amount-text {
    font-size: 28px;
  }

  @media (max-width: 576px) {
    .amount-text {
      font-size: 18px !important;
       textAlign: "start",
    }

  }
    .amount-box-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

@media (max-width: 992px) {
  .amount-box-content {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 10px;
  }

  .amount-box-content .amount-text {
    width: 100%;
    text-align: left !important;
  }
}
          `}</style>

      <Row className="">
        <Col xs={12}>
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              borderRadius: "16px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              padding: "24px",
              border: `2px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7}`,
            }}
          >
            <Row className="g-4 align-items-stretch">
              {/* LEFT CONTENT */}
              <Col xl={6} lg={12} md={12}>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Row className="g-3">
                      <Col xl={12} lg={12} md={6}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            A/c Name :
                          </span>
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "800",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerNormaldata?.LedgerOpening?.[0]?.AcName ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xl={12} lg={12} md={6}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Pan No :
                          </span>
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerNormaldata?.LedgerOpening?.[0]?.PanNo || "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xl={12} lg={12} md={6}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            City :
                          </span>
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerNormaldata?.LedgerOpening?.[0]?.CityName ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xl={12} lg={12} md={6}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-start",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.6",
                            }}
                          >
                            Address :
                          </span>
                          <span
                            style={{
                              fontSize: "15px",
                              fontWeight: "700",
                              lineHeight: "1.6",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            {LedgerNormaldata?.LedgerOpening?.[0]?.Address ||
                              "-"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>

              {/* RIGHT SIDE */}
              <Col xl={6} lg={12} md={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    gap: "12px",
                  }}
                >
                  {/* BOX 1 */}
                  <Col xl={12} lg={12} md={12}>
                    <div
                      className="common-hover-btn"
                      style={{
                        background:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour2,
                        border: `1px solid ${
                          isdark === "light"
                            ? iscolour?.Colour3
                            : iscolourDark?.Colour10
                        }`,
                        borderLeft: `6px solid ${
                          isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour10
                        }`,
                        borderRadius: "12px",
                        width: "100%",
                        padding: "25px",
                        height: "100px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "700",
                            minWidth: "95px",
                            color:
                              isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour12,
                            letterSpacing: "2px",
                          }}
                        >
                          OPENING :
                        </span>

                        <span
                          className="amount-text"
                          style={{
                            fontSize: "28px",
                            fontWeight: "800",
                            textAlign: "center",
                            flex: 1,
                            color:
                              isdark === "light"
                                ? iscolour?.Colour12
                                : iscolourDark?.Colour12,
                            lineHeight: "1",
                          }}
                        >
                          {formatIndianAmount(
                            LedgerNormaldata?.LedgerOpening?.[0]?.OpAmount,
                          )}
                        </span>

                        <div style={{ minWidth: "95px" }}></div>
                      </div>
                    </div>
                  </Col>

                  {/* BOX 2 */}
                  <Col xl={12} lg={12} md={12}>
                    <div
                      className="common-hover-btn"
                      style={{
                        background:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour2,
                        border: `1px solid ${
                          isdark === "light"
                            ? iscolour?.Colour3
                            : iscolourDark?.Colour10
                        }`,
                        borderLeft: `6px solid ${
                          isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour10
                        }`,
                        borderRadius: "12px",
                        width: "100%",
                        padding: "25px",
                        height: "100px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "700",
                            minWidth: "95px",
                            color:
                              isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour12,
                            letterSpacing: "2px",
                          }}
                        >
                          BALANCE :
                        </span>

                        <span
                          className="amount-text"
                          style={{
                            fontSize: "28px",
                            fontWeight: "800",
                            textAlign: "center",
                            flex: 1,
                            color:
                              isdark === "light"
                                ? iscolour?.Colour12
                                : iscolourDark?.Colour12,
                            lineHeight: "1.2",
                          }}
                        >
                          {formatIndianAmount(
                            LedgerNormaldata?.LedgerSumm?.[0]?.Balance || 0,
                          )}
                        </span>

                        <div style={{ minWidth: "95px" }}></div>
                      </div>
                    </div>
                  </Col>
                </div>
              </Col>

              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-end",
                }}
              >
                <button
                  onClick={handleDownload}
                  className="common-hover-btn"
                  style={{
                    background:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour10,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour4,
                    border: "none",
                    borderRadius: "10px",
                    padding: "12px 18px",
                    fontWeight: "700",
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                  }}
                >
                  <FiDownload size={16} />
                  Download PDF
                </button>
              </div>
            </Row>
          </div>
        </Col>

        <Col xs={12}>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  padding: "14px",
                  margin: 0,
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  NORMAL
                </h2>
              </div>
              <FASTable
                data={getRows}
                columns={getColumns}
                externalTotals={LedgerNormaldata?.LedgerSumm?.[0]}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
